<div class="list-wrapper">
  <!-- Mail list header -->
  <div class="header">
    <!-- Header left -->
    <div class="left">
      <!-- Category name -->
      <div class="category">Add Hook</div>
    </div>
    <div class="pagination">
      <!-- Previous page button -->
      <button *ngIf="isActionEnabled" mat-icon-button (click)="addAccountFunction()">
        <mat-icon [svgIcon]="'add_circle_outline'"></mat-icon>
      </button>
    </div>

    <!-- Loading bar -->
    <mat-progress-bar class="loading-progress-bar" *ngIf="mailsLoading" [mode]="'indeterminate'"></mat-progress-bar>
  </div>

  <!-- Mail list -->
  <div class="list" #mailList>
    <!-- Mail list item loop -->
    <ng-container *ngFor="let accountHook of accountHooks; let i = index; trackBy: trackByFn">
      <!-- Mail list item -->
      <a
        class="item"
        [ngClass]="{ selected: selectedAccountHook && selectedAccountHook.id === accountHook.id }"
        [routerLink]="[accountHook.id]"
        (click)="onAccountHookSelected(accountHook)"
      >
        <div class="item-content">
          <div class="info">
            <!-- Sender name -->
            <div class="name">
              {{ accountHook.object_type }}
            </div>
          </div>

          <!-- Subject -->
          <div class="subject">
            <span>{{ accountHook.hook_name }}</span>
          </div>

          <!-- Excerpt -->
          <div class="excerpt">
            {{ accountHook.hook_code | slice: 0 : 80 }}
            <ng-container *ngIf="accountHook.hook_code?.length > 80">...</ng-container>
          </div>
        </div>
      </a>
    </ng-container>
  </div>
</div>

<!-- Mail details -->
<router-outlet *ngIf="accountHooks && accountHooks.length > 0"></router-outlet>
